import script from "./ThrobberLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./ThrobberLoading.vue?vue&type=script&setup=true&lang=js"

import "./ThrobberLoading.vue?vue&type=style&index=0&id=3329d3ff&scoped=true&lang=scss"

import exportComponent from "/home/node/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3329d3ff"]])

export default __exports__